import { render } from "./process_documentation_managementView.vue?vue&type=template&id=784273ae&scoped=true"
import script from "./process_documentation_managementView.vue?vue&type=script&lang=js"
export * from "./process_documentation_managementView.vue?vue&type=script&lang=js"

import "./process_documentation_managementView.vue?vue&type=style&index=0&id=784273ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784273ae"]])

export default __exports__